'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './balance-sheet.routes';

export class BalanceSheetComponent {

  constructor(AccountingService, SettingsService) {
    'ngInject';

    this.AccountingService = AccountingService;
    this.SettingsService = SettingsService;

    this.flattedAccounts = [];

    this.SettingsService.getByName({name: 'chart-of-accounts'}, coa => {
      this.data = coa.data;

      this.data.forEach(headAccount => {
        this.flattedAccounts.push({
          account: headAccount.account,
          code: headAccount.code,
          description: headAccount.description
        });

        if (headAccount.hasOwnProperty('subAccounts')) {

          headAccount.subAccounts.forEach(subAccount => {

            this.flattedAccounts.push({
              account: [headAccount.account, subAccount.account].join(' / '),
              code: subAccount.code,
              description: subAccount.description
            });

            if (subAccount.hasOwnProperty('subAccounts')) {

              subAccount.subAccounts.forEach(subSubAccount => {

                this.flattedAccounts.push({
                  account: [headAccount.account, subAccount.account, subSubAccount.account].join(' / '),
                  code: subSubAccount.code,
                  description: subSubAccount.description
                });

              });

            }

          });

        }
      })

    });
  }
}

export default angular.module('conduuApp.balanceSheet', [uiRouter])
  .config(routes)
  .component('balanceSheet', {
    template: require('./balance-sheet.html'),
    controller: BalanceSheetComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/accounting/balance-sheet/balance-sheet.component.js